/* Osmanlı Panel entegrasyonu — favori butonu + header favori ikonu + yorumlar
   Yönetim: https://www.osmanliyonetim.com (Osmanlı Yönetim Paneli) */
(function () {
  'use strict';
  var cfg = window.ODT_CFG;
  if (!cfg) return;
  var api = cfg.api;
  var store = cfg.store || 'dogaltas';   // hangi mağaza (dogaltas | degerli)
  // GET URL'sine store ekle (mevcut sorgu dizesi varsa & ile)
  function withStore(url) { return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'store=' + encodeURIComponent(store); }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html !== undefined) e.innerHTML = html;
    return e;
  }
  function getJSON(url) {
    return fetch(url).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function postJSON(url, data) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.message || 'İstek başarısız'); return j; }); });
  }
  function stars(n) { var s = ''; for (var i = 1; i <= 5; i++) s += i <= n ? '★' : '☆'; return s; }

  /* ============ HEADER FAVORİ İKONU + AÇILIR LİSTE (her sayfada) ============ */

  var drawer, drawerList, headerCountEl;

  function updateHeaderCount(n) {
    if (!headerCountEl) return;
    headerCountEl.textContent = n;
    headerCountEl.style.display = n > 0 ? '' : 'none';
  }

  function buildDrawer() {
    drawer = el('div', 'odt-drawer');
    drawer.innerHTML =
      '<div class="odt-drawer-ov"></div>' +
      '<div class="odt-drawer-panel">' +
        '<div class="odt-drawer-head"><span>♥ Favorilerim</span><button class="odt-drawer-close" aria-label="Kapat">✕</button></div>' +
        '<div class="odt-drawer-body"></div>' +
      '</div>';
    document.body.appendChild(drawer);
    drawerList = drawer.querySelector('.odt-drawer-body');
    drawer.querySelector('.odt-drawer-ov').addEventListener('click', closeDrawer);
    drawer.querySelector('.odt-drawer-close').addEventListener('click', closeDrawer);
  }

  function openDrawer() {
    if (!drawer) buildDrawer();
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    loadFavItems();
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  function renderFavItems(items) {
    if (!items.length) {
      drawerList.innerHTML = '<div class="odt-drawer-empty">Henüz favori ürününüz yok.<br><span>Beğendiğiniz ürünlerdeki ♡ simgesine dokunun.</span></div>';
      return;
    }
    drawerList.innerHTML = '';
    items.forEach(function (it) {
      var row = el('div', 'odt-fav-row');
      var img = it.image ? '<img src="' + (it.image.indexOf('//') === 0 ? 'https:' + it.image : it.image) + '" alt="">' : '<div class="odt-noimg">🖼</div>';
      row.innerHTML =
        '<a class="odt-fav-link" href="/products/' + it.handle + '">' + img +
          '<span class="odt-fav-t"></span></a>' +
        '<button class="odt-fav-rm" title="Kaldır">🗑</button>';
      row.querySelector('.odt-fav-t').textContent = it.title;
      row.querySelector('.odt-fav-rm').addEventListener('click', function () {
        removeFav(it, row);
      });
      drawerList.appendChild(row);
    });
  }

  function loadFavItems() {
    if (!cfg.customer) return;
    drawerList.innerHTML = '<div class="odt-drawer-empty">Yükleniyor…</div>';
    getJSON(withStore(api + '/favorites/' + cfg.customer.id + '/items')).then(function (d) {
      renderFavItems(d.items || []);
      updateHeaderCount(d.count || 0);
    }).catch(function () {
      drawerList.innerHTML = '<div class="odt-drawer-empty">Liste yüklenemedi.</div>';
    });
  }

  function removeFav(it, row) {
    postJSON(api + '/favorite/toggle', {
      store: store, customer_id: cfg.customer.id, customer_email: cfg.customer.email, customer_name: cfg.customer.name,
      product_id: it.product_id, product_handle: it.handle, product_title: it.title, product_image: it.image
    }).then(function (d) {
      if (!d.favorited) {
        row.style.height = row.offsetHeight + 'px';
        row.classList.add('rm');
        setTimeout(function () {
          row.remove();
          var left = drawerList.querySelectorAll('.odt-fav-row').length;
          updateHeaderCount(left);
          if (!left) renderFavItems([]);
        }, 250);
        // Ürün sayfasındaki buton da güncellensin
        if (cfg.product && cfg.product.id === it.product_id) { favorited = false; syncPageButton(); }
      }
    }).catch(function () {});
  }

  // Header sepet ikonunu bul: önce #cart-icon (Whiff), yoksa görünür /cart bağlantısı (Horizon vb.)
  function findCartIcon() {
    var c = document.getElementById('cart-icon');
    if (c) return c;
    var links = Array.prototype.slice.call(
      document.querySelectorAll('a[href="/cart"], a[href^="/cart?"], a[href$="/cart"]'));
    var vis = links.filter(function (a) { return a.offsetParent !== null; });
    return vis[0] || null; // header genelde ilk görünür /cart bağlantısı
  }

  // Temanın kendi "Favoriler" bağlantısını bul (Horizon'da metni "Favoriler",
  // href genelde işe yaramaz). Varsa onu ele geçirip kendi ikonumuzu EKLEMEYİZ
  // → çift kalp olmaz. Yalnızca header/üst bölge içindekilere bakarız.
  function findThemeFavLink() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(
      'header a, header button, [class*="top"] a, [class*="top"] button, [class*="header"] a, [class*="header"] button, nav a'));
    for (var i = 0; i < nodes.length; i++) {
      var e = nodes[i];
      if (e.id === 'odt-fav-icon' || e.hasAttribute('data-odt-fav')) continue;
      var t = (e.textContent || '').trim().toLowerCase();
      if ((t.indexOf('favori') >= 0 || t.indexOf('wishlist') >= 0) && e.offsetParent !== null) return e;
    }
    return null;
  }

  function fetchHeaderCount() {
    if (!cfg.customer) return;
    getJSON(withStore(api + '/favorites/' + cfg.customer.id + '/items'))
      .then(function (d) { updateHeaderCount(d.count || 0); }).catch(function () {});
  }

  function insertHeaderIcon() {
    if (document.getElementById('odt-fav-icon') || document.querySelector('[data-odt-fav]')) return true;

    // 1) Tema zaten bir "Favoriler" ikonuna sahipse ONU ele geçir (çift kalp olmasın)
    var themeFav = findThemeFavLink();
    if (themeFav) {
      themeFav.setAttribute('data-odt-fav', '1');
      // Sayaç rozeti ekle
      var badge = el('span', 'odt-hcount');
      badge.style.display = 'none';
      themeFav.style.position = themeFav.style.position || 'relative';
      themeFav.appendChild(badge);
      headerCountEl = badge;
      themeFav.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!cfg.customer) { window.location.href = cfg.loginUrl; return; }
        openDrawer();
      }, true);
      fetchHeaderCount();
      return true;
    }

    // 2) Tema favori ikonu yoksa kendi ikonumuzu sepetin yanına ekle (Whiff temaları)
    var cart = findCartIcon();
    if (!cart) return false; // sepet ikonu henüz gelmedi → retry
    var icon = el('a', 'odt-fav-icon');
    icon.id = 'odt-fav-icon';
    icon.href = cfg.customer ? '#' : cfg.loginUrl;
    icon.setAttribute('aria-label', 'Favorilerim');
    icon.innerHTML = '<svg class="odt-hi" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><span class="odt-hcount">0</span>';
    cart.parentNode.insertBefore(icon, cart);
    headerCountEl = icon.querySelector('.odt-hcount');
    headerCountEl.style.display = 'none';

    icon.addEventListener('click', function (e) {
      if (!cfg.customer) return; // href login'e gider
      e.preventDefault();
      openDrawer();
    });

    fetchHeaderCount();
    return true;
  }

  /* ============ ÜRÜN SAYFASI: FAVORİ (temanın [data-fav] butonunu ele geçir) ============ */

  var favorited = false;

  function themeFavButtons() {
    // Whiff teması ürün sayfasında <button data-fav> kullanır (ana + sticky + quick-view).
    // Sadece görünür olanları hedefliyoruz.
    return Array.prototype.slice.call(document.querySelectorAll('[data-fav]'))
      .filter(function (b) { return b.offsetParent !== null && !b.closest('[id*="quick-view"]'); });
  }

  function syncThemeFav() {
    themeFavButtons().forEach(function (btn) {
      btn.classList.toggle('odt-faved', favorited);
      var lbl = btn.querySelector('.odt-own-fav-lbl');
      if (lbl) {                                   // bizim eklediğimiz buton
        lbl.textContent = favorited ? 'Favorilerde' : 'Favorilere Ekle';
      } else if (!btn.querySelector('*')) {        // temanın düz metin butonu
        btn.textContent = (favorited ? '♥ Favorilerde' : '♡ Favorilere Ekle');
      } else {
        btn.classList.toggle('is-active', favorited);
      }
    });
  }

  // Tema kendi favori butonuna sahip DEĞİLSE (ör. degerli teması) kendi butonumuzu
  // sepete-ekle formunun yanına koyarız. Buton [data-fav] taşır; aşağıdaki capture
  // click handler'ı onu da yakalar (dogaltas ile aynı akış).
  function isVisible(elm) {
    if (!elm || elm.offsetParent === null) return false;
    var r = elm.getBoundingClientRect();
    return r.width > 4 && r.height > 4;
  }

  function injectOwnFavButton() {
    // Zaten görünür bir butonumuz varsa iş tamam
    var ex = document.querySelector('.odt-own-fav');
    if (ex) { if (isVisible(ex)) return true; ex.remove(); } // gizli forma düşmüş → kaldır, yeniden dene

    // Sayfada birden çok sepete-ekle formu olabilir (quick-view / sticky / mobil).
    // Yalnızca GÖRÜNÜR olanı hedefle, yoksa gizli forma düşer (0x0 buton olur).
    var cands = Array.prototype.slice.call(document.querySelectorAll(
      'form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [name="add"], ' +
      'product-form button[type="submit"], button[name="add"], ' +
      '.add-to-cart-button, [id*="add-to-cart"]'));  // Horizon vb. temalar
    var atc = cands.filter(function (a) {
      if (!isVisible(a)) return false;
      // SADECE yüzen "sepete ekle" çubuğu / hızlı ekleme / hızlı ödeme kutusunu hariç tut.
      // DİKKAT: genel [class*="sticky"] KULLANMA — Horizon'da ürün bilgi sütunu da "sticky"
      // sınıfı taşır; onu dışlarsak ana "Sepete ekle" butonu da elenir.
      if (a.closest('sticky-add-to-cart, [class*="sticky-add-to-cart"], [class*="quick-add"], [class*="quick-view"], [class*="quickview"], #shopify-accelerated-checkout-cart, [id*="accelerated"]')) return false;
      return true;
    })[0];
    if (!atc) return false;

    var b = el('button', 'odt-own-fav');
    b.type = 'button';
    b.setAttribute('data-fav', '1');
    b.setAttribute('aria-label', 'Favorilere Ekle');
    b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><span class="odt-own-fav-lbl">Favorilere Ekle</span>';
    atc.parentNode.insertBefore(b, atc.nextSibling);

    // Görünür forma girdi mi? Değilse başarısız say (retry başka aday dener)
    return isVisible(b);
  }

  function doFavToggle() {
    if (!cfg.customer) { window.location.href = cfg.loginUrl; return; } // üye değilse üye olma/giriş
    postJSON(api + '/favorite/toggle', {
      store: store, customer_id: cfg.customer.id, customer_email: cfg.customer.email, customer_name: cfg.customer.name,
      product_id: cfg.product.id, product_handle: cfg.product.handle,
      product_title: cfg.product.title, product_image: cfg.product.image
    }).then(function (d) {
      favorited = !!d.favorited;
      syncThemeFav();
      if (cfg.customer) getJSON(withStore(api + '/favorites/' + cfg.customer.id + '/items'))
        .then(function (r) { updateHeaderCount(r.count || 0); }).catch(function () {});
    }).catch(function () { alert('Bir hata oluştu, lütfen tekrar deneyin.'); });
  }

  function setupProductFav() {
    if (!cfg.product) return true;
    var btns = themeFavButtons();
    if (!btns.length) {
      // Tema favori butonu yok → kendi butonumuzu ekle (degerli teması)
      if (!injectOwnFavButton()) return false; // form henüz gelmedi → retry
      btns = themeFavButtons();
      if (!btns.length) return false;
    }
    // Başlangıç durumu
    if (cfg.customer) {
      getJSON(withStore(api + '/favorites/' + cfg.customer.id)).then(function (d) {
        favorited = (d.product_ids || []).indexOf(cfg.product.id) !== -1;
        syncThemeFav();
      }).catch(function () {});
    }
    return true;
  }

  // Tema favori butonu tıklamasını ele geçir (capture — temanın kendi handler'ından önce)
  document.addEventListener('click', function (e) {
    if (!cfg || !cfg.product) return;
    var btn = e.target.closest('[data-fav]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    doFavToggle();
  }, true);

  /* ============ ÜRÜN SAYFASI: YORUMLAR ============ */

  function insertReviews() {
    if (!cfg.product) return;
    var anchor = document.querySelector('.product-page.main-product') ||
                 document.querySelector('main') || document.body;
    var box = el('section', 'odt-reviews');
    box.style.display = 'none';
    box.innerHTML = '<div class="odt-reviews-inner"><h3 class="odt-reviews-title">Müşteri Yorumları</h3>' +
      '<div class="odt-reviews-summary"></div><div class="odt-reviews-list"></div></div>';
    if (anchor === document.body) anchor.appendChild(box);
    else anchor.insertAdjacentElement('afterend', box);

    var summary = box.querySelector('.odt-reviews-summary');
    var list = box.querySelector('.odt-reviews-list');
    getJSON(withStore(api + '/reviews?product_id=' + cfg.product.id)).then(function (d) {
      if (d.count > 0) {
        box.style.display = '';
        summary.innerHTML = '<span class="odt-stars">' + stars(Math.round(d.average)) + '</span> <strong>' +
          d.average + '/5</strong> · ' + d.count + ' değerlendirme';
        d.reviews.forEach(function (r) {
          var item = el('div', 'odt-review');
          item.innerHTML = '<div class="odt-review-head"><strong></strong><span class="odt-stars">' + stars(r.rating) +
            '</span><span class="odt-verified">✓ Doğrulanmış Alıcı</span><span class="odt-review-date">' + r.date +
            '</span></div><p class="odt-review-body"></p>';
          item.querySelector('strong').textContent = r.author;
          item.querySelector('p').textContent = r.content;
          list.appendChild(item);
        });
      }
    }).catch(function () { box.remove(); });
  }

  /* ============ BAŞLAT ============ */

  function ensure(fn) {
    var tries = 0;
    (function attempt() {
      try { if (fn()) return; } catch (e) {}
      if (tries++ < 25) setTimeout(attempt, 400);
    })();
  }

  function init() {
    ensure(insertHeaderIcon);            // her sayfada
    if (cfg.product) {
      ensure(setupProductFav);           // temanın favori butonunu ele geçir
      try { insertReviews(); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
